import type { Column } from '../../claim-history/simple-table'
import type { Alert } from '../queries/alerts'

import LinkIcon from '@material-design-icons/svg/filled/link.svg?component'
import _ from '../../../utils/lodash-optimized'
import { useCallback, useMemo } from 'react'
import { Link } from 'react-router-dom'

import { routeMap } from '../../../constants'
import * as Table from '../../claim-history/simple-table'
import { useTableSort } from '../../claim-history/simple-table/use-sort-hook'
import * as Card from '../../shared/card'
import { FriendlyDateTime } from '../../shared/Date/friendly-date-time'
import { useAlerts } from '../queries/alerts'

export function Alerts (): JSX.Element {
  const alertsQuery = useAlerts()
  const { sort, setSort } = useTableSort<Alert>({ field: 'created_at', direction: 'desc' })

  const columns = useMemo((): Array<Column<Alert> & {onSort?: (a: Alert, b: Alert) => number}> => [
    {
      name: 'status',
      header: 'Level',
        getValue: (x) => _.upperCase(x?.status)
    },
    {
      name: 'patient_last_name',
      isSortable: true,
      header: 'Last',
      getValue: a => (
        <Link
          to={`/patient/${a.client_name}/${a.patient_id}/patientFolder`}
        >
          {a.patient_last_name}
        </Link>
      )
    },
    {
      name: 'patient_first_name',
      isSortable: true,
      header: 'First',
      getValue: a => a.patient_first_name
    },
    {
      name: 'issue',
      header: 'Issue',
      getValue: a => (a.title ?? '').replace(/ -> /g, ' → ')
    },
    {
      name: 'created_at',
      header: 'Reported',
      isSortable: true,
      getValue: a => <FriendlyDateTime datetime={a?.created_at} />
    }
  ], [])

  const applyFilter = useCallback(() => {
    const sortFn = columns.find((c) => c.name === sort.field)?.onSort

    let data

    if (sortFn) {
      data = alertsQuery?.data?.sort(sortFn) ?? []
    } else {
      data = alertsQuery.data?.sort((a, b) => {
        const aEl = (a?.[sort?.field] as string)?.toString()
        const bEl = (b?.[sort?.field] as string)?.toString()
        return aEl.localeCompare(bEl)
      }) ?? []
    }

    if (sort?.direction === 'desc') {
      data.reverse()
    }

    return data
  }, [ columns, sort.field, sort?.direction, alertsQuery?.data ])

  const data = applyFilter()

  return (
    <Card.Card>
      <Card.Header>

        <Link
          to={routeMap.DASHBOARD.ALERTS}
          className='flex flex-row gap-1 items-center'
        >
          <h2>
            Alerts
          </h2>
          <LinkIcon fill='#222' />
        </Link>

      </Card.Header>
      <Table.Table
        expandable={false}
        data={data ?? []}
        error={alertsQuery.error as Error}
        fetchStatus={alertsQuery.fetchStatus}
        queryStatus={alertsQuery.status}
        sort={sort}
        onSortChange={(field, direction) => setSort({ field, direction })}
        noDataPlaceholder='There are no Alerts to display'
        columns={columns}
        disableMinHeight
      />
    </Card.Card>

  )
}
